import { Banner } from "@minuthq/meatball-ui-react"

import { EmptyState } from "src/components/EmptyState"
import { ParadiseDetailsLayout } from "src/components/Paradise/ParadiseDetailsLayout"
import { ParadiseWarehouseInventory } from "src/components/Paradise/ParadiseWarehouses/ParadiseWarehouseDetails/ParadiseWarehouseInventory"
import { ParadiseWarehouseMeta } from "src/components/Paradise/ParadiseWarehouses/ParadiseWarehouseDetails/ParadiseWarehouseMeta"
import { ParadiseWarehouseOverview } from "src/components/Paradise/ParadiseWarehouses/ParadiseWarehouseDetails/ParadiseWarehouseOverview"
import { LoadingWrapper } from "src/components/Paradise/sharedStyles"
import { useAddRecentlyViewedPage } from "src/components/RecentlyViewed/useAddRecentlyViewedPage"
import { useFetchWarehouses } from "src/data/ecommerce/ecommerceQueries"
import { useTranslate } from "src/i18n/useTranslate"
import { Routes } from "src/router/routes"
import Svg404 from "src/ui/icons/404.svg"
import { MSkeleton } from "src/ui/MSkeleton/MSkeleton"
import { formatUtcDate } from "src/utils/l10n"

export function ParadiseWarehouseDetails({
  warehouseId,
}: {
  warehouseId: string
}) {
  const { t, langKeys } = useTranslate()

  const fetchParadiseWarehouse = useFetchWarehouses()

  const warehouse = fetchParadiseWarehouse.data?.find(
    (warehouse) => warehouse.id === warehouseId
  )

  useAddRecentlyViewedPage({
    title: warehouse?.id,
    enitytId: warehouse?.id,
    type: "Warehouse",
    enabled: !!warehouse,
  })

  if (fetchParadiseWarehouse.isError) {
    return (
      <EmptyState
        title={t(langKeys.failed_general_error_title)}
        body={t(langKeys.failed_general_error_body)}
        icon={<Svg404 />}
      />
    )
  }

  if (fetchParadiseWarehouse.isLoading || !warehouse) {
    return (
      <LoadingWrapper>
        <MSkeleton height={40} width="30ch" />
        <MSkeleton height={20} width="40ch" />
      </LoadingWrapper>
    )
  }

  return (
    <ParadiseDetailsLayout
      meta={<ParadiseWarehouseMeta warehouse={warehouse} />}
      banner={
        warehouse.deleted && warehouse.deleted_at ? (
          <Banner type="error" fullWidth>
            Warehouse was deleted at{" "}
            {formatUtcDate({
              date: warehouse.deleted_at,
              excludeTime: true,
            })}
          </Banner>
        ) : null
      }
      left={<ParadiseWarehouseOverview warehouse={warehouse} />}
      right={<ParadiseWarehouseInventory warehouse={warehouse} />}
      breadcrumbs={[
        {
          label: "Warehouses",
          to: Routes.ParadiseWarehouses.location(),
        },
        {
          label: warehouseId,
          to: Routes.ParadiseWarehouse.location(warehouseId),
        },
      ]}
      breadcrumbCopyValue={warehouseId}
    />
  )
}
